import { Skeleton } from '@mui/material';

const UserSkeleton = () => {
    return <div>
        <Skeleton
            variant="rectangular"
            width='100%'
            height={120}
            animation={false}
        />
        <div style={{ display: 'flex', gap: '12px' }}>
            <Skeleton
                variant="circular"
                width={80}
                height={80}
                style={{ marginTop: '-40px', marginLeft: '40px' }}
                animation={false}
            />
            <Skeleton
                variant="text"
                width={60}
                height={10}
                style={{ marginTop: '12px' }}
            />
        </div>
    </div>;
};

export default UserSkeleton;